import{useContext as o}from"../../../../external/preact/hooks/dist/hooks.js";import{ClickToPayContext as t}from"./ClickToPayContext.js";function e(){return o(t)}export{e as default};
